import { call, put, select } from 'redux-saga/effects';
import { actionActions } from 'store/data/action';
import { deleteAction } from 'store/glue/operation/deleteAction';
import { sagaWrapper } from 'store/helpers';
import { ActionType } from 'typesafe-actions';

import * as improvementsActions from './actions';
import * as constants from './constants';
import * as improvementsSelectors from './selectors';

// Deselects the action if it is currently selected, then either:
//  - drops the unsaved mock placeholder from the store directly, or
//  - delegates to the deleteAction operation which calls the API and
//    removes the entity from the store on success.
export function* startDeleteActionSaga(
  _action: ActionType<typeof improvementsActions.startDeleteAction>,
) {
  function* saga() {
    const { actionId } = _action.payload;

    const selectedActionId: ReturnType<
      typeof improvementsSelectors.selectedActionId
    > = yield select(improvementsSelectors.selectedActionId);

    if (selectedActionId === actionId)
      yield put(improvementsActions.setSelectedActionId(null));

    // The mock placeholder lives only in the store; nothing to delete server-side.
    if (actionId === constants.MOCKED_ACTION_ID) {
      yield put(actionActions.remove(actionId));
      return;
    }

    yield call(deleteAction, { actionId });
  }

  yield call(sagaWrapper, { saga, type: _action.type });
}
